module.exports = __webpack_public_path__ + "static/media/Male.6b6e2060.svg";